import { render, staticRenderFns } from "./CancelContent.vue?vue&type=template&id=2d70ac9e&scoped=true"
import script from "./CancelContent.vue?vue&type=script&lang=js"
export * from "./CancelContent.vue?vue&type=script&lang=js"
import style0 from "./CancelContent.vue?vue&type=style&index=0&id=2d70ac9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70ac9e",
  null
  
)

export default component.exports